import {Injectable} from "@angular/core";
import {BehaviorSubject} from "rxjs";
import {getEventConfig} from "../constants/event-config";
import {filter} from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class EventRegistrationService {

  private _orderSummary = new BehaviorSubject<OrderSummary | null>(null)
  public orderSummary$ = this._orderSummary.asObservable().pipe(filter((value) => !!value));

  updateOrderSummary(event_id: number, eventRegistrationForm: any) {
    const eventConfig = getEventConfig(event_id);
    const priceDateIndex = eventConfig?.priceDates.findIndex(date => new Date(date).valueOf() >= new Date().valueOf()) || 0;
    this._orderSummary.next({
      price: eventConfig?.pricesByGroups.find(group => group.group_id === eventRegistrationForm.race_details.group)?.prices[priceDateIndex] || 0,
      commission: eventConfig?.commission || 0,
      name: `Ticket "${eventConfig?.groupOptions?.find(group => group.id === eventRegistrationForm.race_details.group)?.itemName}"`
    });
  }

  get orderSummary(): OrderSummary | null {
    return this._orderSummary.value;
  }
}

export interface OrderSummary {
  name: string,
  price: number,
  commission: number
}
